import React, { useState } from 'react';
import './Dashboard.css';
import { MdDashboard } from "react-icons/md";
import { FaSyncAlt } from "react-icons/fa";
import { FaRegHeart } from "react-icons/fa6";
import { HiOutlineShoppingBag } from "react-icons/hi2";
import { IoSettingsOutline } from "react-icons/io5";
import { BiLogIn } from "react-icons/bi";
import { FaRegAddressBook } from "react-icons/fa";
import { TbLockPassword } from "react-icons/tb";
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { logOut, logOutSuccess } from '../../store/auth/action';
import { setWishlist } from '../../store/wishlistSlice';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import Wishlistdash from '../User-Dashboard/Wishlistdash';
function Dashboardmy() {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const [showLogoutPopup, setShowLogoutPopup] = useState(false);

    const handleLogoutClick = () => setShowLogoutPopup(true);
    const handleLogoutCancel = () => setShowLogoutPopup(false);

    const handleLogoutConfirm = () => {
        // toast.success("Logged out successfully! See you soon!", {
        //     autoClose: 3000,
        //     hideProgressBar: false,
        //     closeOnClick: true,
        //     pauseOnHover: true,
        //     draggable: true,
        // });
        dispatch(logOut());
        dispatch(logOutSuccess());
        dispatch(setWishlist([]));
        setShowLogoutPopup(false);
    };

    // Function to check if a link is active
    const isActive = (path) => location.pathname === path;

    return (
        <>
            {/* <ToastContainer /> */}
            <div className="dashboard-container">
                {/* Sidebar */}
                <div className="dashboard-nav">
                    <div className="dashboard-nav__heading">Navigation</div>

                    <div
                        className={`dashboard-nav__link ${isActive('/user') ? 'dashboard-nav__link--active' : ''}`}
                        onClick={() => navigate('/user')}
                    >
                        <MdDashboard className="dashboard-nav__icon" />
                        <span>Dashboard</span>
                    </div>

                    <div
                        className={`dashboard-nav__link ${isActive('/order_view') ? 'dashboard-nav__link--active' : ''}`}
                        onClick={() => navigate('/order_view')}
                    >
                        <FaSyncAlt className="dashboard-nav__icon" />
                        <span>Orders</span>
                    </div>

                    <div
                        className={`dashboard-nav__link ${isActive('/wishlistdashboard') ? 'dashboard-nav__link--active' : ''}`}
                        onClick={() => navigate('/wishlistdashboard')}
                    >
                        <FaRegHeart className="dashboard-nav__icon" />
                        <span>Wishlist</span>
                    </div>

                    <div
                        className={`dashboard-nav__link ${isActive('/address') ? 'dashboard-nav__link--active' : ''}`}
                        onClick={() => navigate('/address')}
                    >
                        <FaRegAddressBook className="dashboard-nav__icon" />
                        <span>Address</span>
                    </div>

                    <div
                        className={`dashboard-nav__link ${isActive('/changepass') ? 'dashboard-nav__link--active' : ''}`}
                        onClick={() => navigate('/changepass')}
                    >
                        <TbLockPassword className="dashboard-nav__icon" />
                        <span>Change Password</span>
                    </div>

                    <div
                        className={`dashboard-nav__link ${isActive('/cartdashboard') ? 'dashboard-nav__link--active' : ''}`}
                        onClick={() => navigate('/cartdashboard')}
                    >
                        <HiOutlineShoppingBag className="dashboard-nav__icon" />
                        <span>Cart</span>
                    </div>
                         <div
                        className={`dashboard-nav__link ${isActive('/cartdashboard') ? 'dashboard-nav__link--active' : ''}`}
                        onClick={() => navigate('/subscription')}
                    >
                        <HiOutlineShoppingBag className="dashboard-nav__icon" />
                        <span>Subscription</span>
                    </div>

                    <div
                        className={`dashboard-nav__link ${isActive('/Nat') ? 'dashboard-nav__link--active' : ''}`}
                        onClick={() => navigate('/Nat')}
                    >
                        <IoSettingsOutline className="dashboard-nav__icon" />
                        <span>Settings</span>
                    </div>

                    <div className="dashboard-nav__link" onClick={handleLogoutClick}>
                        <BiLogIn className="dashboard-nav__icon" />
                        <span>Log-out</span>
                    </div>
                </div>

                {/* Logout Confirmation Popup */}
                {showLogoutPopup && (
                    <div className="logout-popup-overlay">
                        <div className="logout-popup">
                            <h3>Confirm Logout</h3>
                            <p>Are you sure you want to logout?</p>
                            <div className="logout-popup-buttons">
                                <button className="logout-confirm-btn" onClick={handleLogoutConfirm}>Yes</button>
                                <button className="logout-cancel-btn" onClick={handleLogoutCancel}>No</button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
}

export default Dashboardmy;
